module.exports = __webpack_public_path__ + "static/media/Goal-Header-Desktop.f7756a51.mp4";